module.exports = __webpack_public_path__ + "static/media/AB_L31_10.7fb922e3.jpg";